angular.module("avant.filters").filter "ProductPaymentMethod", ->
  (input) ->
    switch input
      when "ach"                    then "ACH"
      when "remotely_created_check" then "Remotely Created Check"
      when "paper_check"            then 'Paper Check'
      else input
